import React from "react";
import PageTitle from "../components/PageTitle";
import BlogForm from "../components/BlogPage/SingleBlog/BlogForm";
import "./AddBlogPage.css";

const AddBlogPage: React.FC = () => {
    return (
        <div>
            <PageTitle pageName="" desc="" id="add-blog"/>
            <section className="blog-pg-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-md">
                            <div className="blog-content">
                                <BlogForm />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AddBlogPage;